import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref, watch } from 'vue';
import { removeBodyScroll } from '@/modules/common/helpers/browser';

import {
  NavBar,
  Heading,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { IMarginAllocationV2 } from '@/modules/trade/services/margin-allocation';

interface EmitEvents {
  (event: 'close'): void;
}
interface Props {
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RecurringLimit',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
};





const updatePreference = inject('fetchUpdatePreference', async () => ({}));
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;

const isLoading = ref(false);

const data = computed(() => {
  return marginAllocation.value.recurringLimit;
});

async function fetchUpdate() {
  try {
    isLoading.value = true;

    await updatePreference();
  } finally {
    isLoading.value = false;
    emit('close');
  }
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,emit, props, updatePreference, marginAllocation, isLoading, data, fetchUpdate, NavBar, Heading, BaseText, ButtonContainer, ButtonPrimary, ButtonSecondary, SideSheet, BackButton }
}

})